import React, { useState, useEffect } from 'react'
import API from '../utils/api';
import { Button, Card, InputGroup, FloatingLabel, Form, Row, Col, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { TicketDetailed, Search } from 'react-bootstrap-icons';
import Table from 'react-bootstrap/Table';
import { Container } from 'react-bootstrap';
import ExportExcel from '../utils/excelexports.js'
import { formatearFecha } from '../utils/FormatearFecha';
import Pagination from '../utils/Pagination'
import { Input, Label } from "reactstrap";
import swal from 'sweetalert';

const PrestamosFinalizados = () => {

  var url = API.urlAPI
  const urlPrestamo = url + "Prestamos/BuscarPrestamos"

  const [prestamos, setPrestamos] = useState([]);
  const [prestamoDetalles, setPrestamoDetalles] = useState([]);

  const [search, setSearch] = useState("")
  // COdigo para paginado
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = prestamos.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(prestamos.length / recordsPerPage)


  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [estado, setEstado] = useState('')


  const getPrestamo = async () => {

    if ([fechaFin, fechaInicio, estado].includes(''))
    {
      swal("", "Todos los campos deben tener valores", "info");
    }
    else
    {
      let res = await fetch(urlPrestamo + "/" + estado + "/" + fechaInicio + "/" + fechaFin)
      let data = await res.json()
      console.log("Resultado API: ", data)
      setPrestamos(data)
      setPrestamoDetalles(data.prestamos.prestamodetalles)
      console.log(prestamos);
      
      console.log("detalles: ",prestamoDetalles);
      console.log("Fecha", fechaInicio)
    }
 
  }



  const getColor = (estadoFila) => {
    if (estadoFila == "Atrasado") return '#ff6961';
    if (estadoFila == "En Curso") return '#fefda6';
    return '';
  };

  const ContainerStyle = {
    boxShadow: '1px 2px 9px white',
    background: 'white'
  };

  const searcher = (e) => {
    setSearch(e.target.value)
  }
  const results = !search ? currentRecords : prestamos.filter((dato) => dato.IdPrestamo.toString().includes(search.toLocaleLowerCase()) || dato.Cliente.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || dato.Estado.toLocaleLowerCase().includes(search.toLocaleLowerCase()))

  const cambioFecha = e => {
    console.log(e.target.value)
  }
  return (
    <>
      <br></br>
      <Container>

        <br></br>
        <Card style={ContainerStyle} >
          <Card.Header style={{ background: "#005187", color: "white" }}><h3>Historial Créditos</h3></Card.Header>
          <Card.Body>
            <Row className="align-items-end">
              <Col sm={2}>
                <FormGroup>
                  <Label>Fecha Inicio:</Label>
                  <Form.Control type="date"
                    selected={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                    dateFormat='dd-MM-yyyy' />

                </FormGroup>
              </Col>

              <Col sm={2}>
                <FormGroup>
                  <Label>Fecha Fin:</Label>
                  <Form.Control type="date"
                    selected={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                    dateFormat='dd-MM-yyyy' />


                </FormGroup>
              </Col>

              <Col sm={2}>
                <FormGroup>
                  <Label>Estado:</Label>
                  <Input type="select" name="selectMulti" onChange={(e) => setEstado(e.target.value)} >
                  <option value="">Seleccionar Estado</option>
                    <option value= "Pendiente">Pendiente</option>
                    <option value= "En Curso">En Curso</option>
                    <option value= "Finalizado">Finalizado</option>
                    <option value= "X">Todos</option>
                  </Input>
                  </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>

                  <Label></Label>
                  <Button variant="success" onClick={() => getPrestamo()}>
                    <Search size={20} /></Button>
                </FormGroup>

              </Col>
            </Row>
            <br></br>
            <br></br>
            <InputGroup>
              <InputGroup.Text><Search /></InputGroup.Text>
              <FloatingLabel
                controlId="floatingInput"
                label="Busqueda por Cliente, Estado o N° de Prestamo"
              >
                <Form.Control value={search} onChange={searcher} type="text" />
              </FloatingLabel>
            </InputGroup>
            <br></br>
            <Table responsive >
              <thead>
                <tr style={{ background: "#5589c4", color: "white" }}>
             
                  <th>N° Crédito</th>
                  <th>Cliente</th>
                  <th>Modalidad</th>
                  <th>Tasa Interes</th>
                  <th>Importe Credito</th>
                  <th>Cantidad de Cuotas</th>
                  <th>Importe de Cuota</th>
                  <th>Total Financiado</th>
                  <th>Estado</th>
                  <th>Fecha Alta</th>
                  <th>Fecha Vencimiento</th>
                  <th>Medio de pago</th>

                </tr>
              </thead>
              <tbody>
                {results.map((item) =>

                  <tr key={item.IdPrestamo} style={{ background: getColor(item.Estado) }}>
                 
                    <td>{item.IdPrestamo}</td>
                    <td>{item.Cliente}</td>
                    <td>{item.Modalidad == '7' && <td>Semanal</td>
                    }
                      {item.Modalidad == '31' && <td>Mensual</td>}
                      {item.Modalidad == '1' && <td>Diario</td>}
                      {item.Modalidad == '15' && <td>Quincenal</td>}
                    </td>
                    <td>{item.TasaInteres}</td>
                    <td>{item.ImporteCredito}</td>
                    <td>{item.CantCuotas}</td>
                    <td>{item.ImporteCuota}</td>

                    <td>{item.ImporteCuota * item.CantCuotas}</td>
                    <td>{item.Estado}</td>
                    <td>{formatearFecha(item.FechaAlta)}</td>
                    <td>{formatearFecha(item.fechaMinimaVencimiento)}</td>
                    <td>{item.MedioPago}</td>
                  </tr>
                )}
              </tbody>
            </Table>
            <Pagination
              nPages={nPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
            <ExportExcel excelData={prestamos} fileName={"Historico Prestamos"} />
          </Card.Body>
        </Card>
      </Container>


    </>
  )
}

export default PrestamosFinalizados